import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function AmcSla() {
  return <DetailPage type="service" id="amc-sla" />;
}
